import store from '@/store'
import { Operation } from './enums'
import type { IFileUploadConfig } from './type'
import { computed } from 'vue'
import { downloadAsset } from '@/api/public_resource'
import type { AssetListItem } from '@/api/public_resource/type'
import { TabsType } from './enums'
import type { fileListType, fileMetaType } from '@/api/public_resource/type'

const resource = computed(() => store.state.resource)

export function openVisibleDialog(): void {
  store.commit('resource/updateVisible', true)
}

// 查看资源
export function handleResourceConfig(row: AssetListItem, type: string): void {
  openVisibleDialog()

  resource.value.dialogFormInfo =
    type === Operation.DELETE
      ? { id: row.id, operation: type }
      : { ...row, operation: type }
  // Object.assign(row, { operation: type })
}

// 资源下载
export async function handleDownloadConfig(id: string): Promise<void> {
  const res = await downloadAsset({ ids: id })
  window.open(res.data.data.download_url, '_blank')
}

export function getFileUploadConfig(value: number): IFileUploadConfig {
  let acceptType: string[] = []
  let tip = ''
  switch (value) {
    case TabsType.KEEL:
      acceptType = ['zip']
      tip =
        '龙骨：仅支持zip格式，zip包内容必须符合龙骨文件规范（一个图片+2个json文件）'
      break
    case TabsType.VIDEO:
      acceptType = ['mp4']
      tip = '视频：仅支持mp4格式的文件，文件最大不能超过1.5G'
      break
    case TabsType.PICTURE:
      acceptType = ['jpg', 'png', 'bmp', 'svg']
      tip = '图片：仅支持jpg, png, bmp,svg格式图片'
      break
    case TabsType.GRAPH:
      acceptType = ['gif', 'zip']
      tip = '动图：仅支持gif、zip（zip包中只能为图片内容（png））格式的文件'
      break
    case TabsType.AUDIO:
      acceptType = ['mp3']
      tip = '音频：仅支持上传MP3格式的文件'
      break
    case TabsType.PARTICLE:
      acceptType = ['zip', 'unitypackage']
      tip =
        '粒子：仅支持zip/unitypackage格式，若为zip包，则zip包中只能有三个文件分别以（.bin,.meta,.prefab）结尾'
      break
    case TabsType.FONT:
      acceptType = ['ttf', 'otf']
      tip = '字体：仅支持ttf、otf格式'
      break
    case TabsType.FLOWERWORD:
      acceptType = ['zip']
      tip = '花字：仅支持zip格式，文件最大不能超过5M'
      break
    case TabsType.TRANSITION:
      acceptType = ['zip']
      tip = '转场：仅支持zip格式，文件最大不能超过5M'
      break
    case TabsType.FILTER:
      acceptType = ['zip']
      tip = '滤镜：仅支持zip格式，文件最大不能超过5M'
      break
    case TabsType.ANIMATION:
      acceptType = ['zip']
      tip = '动画：仅支持zip格式，文件最大不能超过5M'
      break
    case TabsType.MODEL:
      acceptType = ['zip']
      tip =
        '模型：仅支持zip格式（文件格式必须为gltf/glb/(glb+bin)+jpg/png），文件最大不能超过5M'
      break
    case TabsType.ACTION:
      acceptType = ['glb']
      tip = '动作：仅支持 glb 格式，文件最大不能超过5M'
      break
    default:
      acceptType = [
        'zip',
        'mp4',
        'jpg',
        'png',
        'bmp',
        'svg',
        'gif',
        'mp3',
        'unitypackage',
        'ttf',
        'otf',
      ]
      tip = '全部类型'
      break
  }
  return { acceptType, tip }
}

// 预览
export function updateViewDialog(val: {
  id?: number
  visible: boolean
  preview_urls?: string[]
  name?: string
  type?: number
  skeleton_type?: number
  file_list?: fileListType[]
  file_meta?: fileMetaType
}): void {
  store.commit('resource/updateViewDialog', val)
}
